import { Component, AfterViewInit } from '@angular/core';
//import { MsalBroadcastService } from '@azure/msal-angular';
import { PreloaderService } from '@core';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements AfterViewInit {
  constructor(private preloader: PreloaderService) {}

  ngAfterViewInit() {
    this.preloader.hide();
  }
}
